import { getGraphQLClientInsights } from 'utilities/graphql';

import CtaClick from './ctaClick.graphql';
import DownloadClick from './downloadClick.graphql';

let client;

export function trackCtaClick(videoId: string, sessionId: string): void {
  sendMutation(CtaClick, { videoId, sessionId });
}

export function trackDownloadClick(videoId: string, sessionId: string): void {
  sendMutation(DownloadClick, { videoId, sessionId });
}

function sendMutation(mutation, variables) {
  if (!client) {
    client = getGraphQLClientInsights();
  }

  client.mutate({
    mutation,
    variables,
  });
}
